import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GalleryListPageRoutingModule } from './gallery-list-routing.module';
import { GalleryListPage } from './gallery-list.component';
import { BackboneComponent } from '@components/backbone/backbone.component';
import { PlaceholderTableComponent } from '@components/placeholders/table/table.component';
import { HeaderPageTitleBoxComponent } from '@components/headers/page-title-box/page-title-box.component';
import { ButtonModule } from 'primeng/button';
import { ShowForPermissionsDirective } from '@directives/show-for-permissions.directive';

@NgModule({
  declarations: [
    GalleryListPage
  ],
  imports: [
    CommonModule,
    GalleryListPageRoutingModule,
    BackboneComponent,
    PlaceholderTableComponent,
    HeaderPageTitleBoxComponent,
    ButtonModule,
    ShowForPermissionsDirective
  ]
})
export class GalleryListPageModule { }
